// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3944d592","703":"2a6cd258","787":"abd36950"}[chunkId] + ".chunk.js";
};